import React, { useEffect, useRef } from 'react'
import './style.css'
import TopBar from '../../components/general/topbar/TopBar';
import EquiposTecnoRef from '../../assets/images/banners/webps/equipostecnoref.webp'
import EquiposTecnoRef2 from '../../assets/images/banners/webps/equipostecnoref2.webp'
import LogoTecnoref from '../../assets/images/banners/webps/logotecnoref.webp'
import Vehiculos from '../../assets/images/banners/webps/Vehiculos.webp'
import Footer from '../../components/general/footer/Footer';
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Transport() {

  let equipos = useRef();

  useEffect(() => {

    window.addEventListener('resize', () => {
      if(equipos != null){
        if(equipos.current.width < 600){
          equipos.current.src = EquiposTecnoRef2;
        }else{
          equipos.current.src = EquiposTecnoRef;
        }
      }
    })

    window.scroll(0,0)
  })

  let navigate = useNavigate();

  const metaTags = {
    title: "Refrigeración para el transporte",
    description: "Desde nuestro área de servicios, nos dedicamos a la reparación y mantenimiento de equipos de frio para el transporte refrigerado (multimarca), para su flota",
    url: "https://www.nicolinirefrigeracion.com.ar/productos/transporte"
  }

  return (
    <div className='Products'>
      
      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={EquiposTecnoRef} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={EquiposTecnoRef} />
      </Helmet>

      <TopBar />
      <div className='pageDisplay' id='d1'>
        <div id='div1'>

        </div>
        <div id="div2">
          <h2 className='title'>Equipos de Frío</h2>
          <p className='text'>{"Desde nuestro área de servicios, nos dedicamos a la reparación y mantenimiento de equipos de frio para el transporte refrigerado (multimarca), para su flota. Nos aseguramos contar con un stock de repuestos originales para las principales marcas del mercado."}</p>
        </div>
      </div>
      <div className='pageDisplay' id='d2'>
        <div id="div1">
          <img id='logoTR' src={LogoTecnoref} alt='Logo de la empresa fabricante de equipos de frío para el transporte, Tecno Ref'></img>
          <p className='text'>{"Somos concesionario oficial Tecno-ref de la localidad de Rosario, agentes autorizados para la venta de equipos de frío, repuestos originales y servicio técnico de equipos"}</p>
        </div>
        <div id="div2">
          <img src={Vehiculos} alt='Vehículos equipados con equipos de frio para transporte. Desde utilitarios pequeños hasta grandes furgones'/>
        </div>
      </div>
      <div className='pageDisplay' id='d4'>
        <div id="div1">
          <iframe className='socialMediaFrame' scrolling='no' src='https://www.instagram.com/p/DJaM8amxQRn/embed'></iframe>
        </div>
        <div id="div2">
          <iframe className='socialMediaFrame' scrolling='no' src='https://www.instagram.com/p/DI12QIDxrSm/embed'></iframe>
        </div>
      </div>
      <div className='pageDisplay' id='d2'>
        <div id="div1">
          <h2 className='title'>Aislaciones a medida</h2>
          <p className='text'>{"Revestimiento térmico sobre unidades. Sin quitar capacidad de almacenamiento, con un excelente acabado y detalle, asegura el rendimiento óptimo de los equipos Tecno-ref."}</p>
        </div>
        <div id="div2">
          <h2 className='title'>Equipamiento</h2>
          <p className='text'>{"Para utilitarios (pequeños, medianos y grandes), Camiones de 4 y 8 metros. Temperaturas de acuerdo a sus necesidades: 0º, -5º y supercongelados -25º."}</p>
        </div>
      </div>
      <div className='pageDisplay' id='d6'>
         <a href='https://wa.me/5493434178703?text=%C2%A1Hola!+Quisiera+pedir+cotización+por+un+equipo+de+frío' target='_blank'><ButtonMinimalist text={"Pida su cotización aquí"} /></a>
      </div>
      <div className='pageDisplay' id='d5'>
        <div id="div1">
        </div>
        <img src={EquiposTecnoRef} alt='Muestra de las aislaciones y equipos Tecno Ref para utilitarios' ref={equipos}/>  
      </div>
      <div className='pageDisplay' id='d3'>
        <div id="div1">
          <h2 className='title'>Asesoramiento</h2>
          <p className='text'>{"Te asesoramos en lo que necesites"}</p>
        </div>
        <div id="div2">
          <ButtonMinimalist text={"Preguntas Frecuentes"} onClick={() => navigate("/faq")} />
          <div id='faq-example'>
            <p className='textMini'>{"¿Cual equipo me conviene?"}</p>
            <p className='textMini'>{"¿De cuanto tiempo es la garantía?"}</p>
            <p className='textMini'>{"¿Viene incluida la aislación?"}</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}